export const randomWholeNumberInRange = (min: number, max: number): number =>
    Number((Math.random() * (max - min) + min).toFixed(0));

export const anyNumberInNumberArray = (
    arr1: number[],
    arr2: number[],
): boolean =>
    arr1.reduce((found, num) => found || arr2.includes(num), false as boolean);
